import {
    ACTION_LOADING,
    ACTION_SUCCESS,
    ACTION_ERROR,
    ACTION_SUBMITING,
    ACTION_SUBMITED,
    GET_ADS,
    GET_ADS_LIST,
    ADS_SEARCH,

} from "../../actions/admin/AdsActions";

const initialState = {
    currentAds: {},
    adsList: [],
    adsSearchResult: {},
    loading: false,
    success: false,
    failed: false,
    submitting: false
};

const AdsReducer = function (state = initialState, action) {
    switch (action.type) {

        case ACTION_LOADING: {
            return {
                ...state,
                loading: true,
                success: false,
                failed: false
            };
        }
        case ACTION_SUCCESS: {
            return {
                ...state,
                success: true,
                loading: false,
                failed: false,
            };
        }
        case ACTION_ERROR: {
            return {
                ...state,
                failed: true,
                success: false,
                loading: false,
                showAlert: true,
                alertMessage: action.data,
            };
        }
        case ACTION_SUBMITING: {
            return {
                ...state,
                submitting: true
            };
        }
        case ACTION_SUBMITED: {
            return {
                ...state,
                submitting: false
            };
        }
        case GET_ADS_LIST: {
            return {
                ...state,
                adsList: [...action.data]
            };
        }
        case ADS_SEARCH: {
            return {
                ...state,
                adsSearchResult: { ...action.data }
            };
        }

        case GET_ADS: {
            return {
                ...state,
                currentAds: { ...action.data }
            };
        }
        default: {
            return state;
        }
    }
};

export default AdsReducer;
